import { Fragment, useEffect, useRef } from "react";
import './ContactTimeline.scss'
import ContactTimeFrame from "./ContactTimeFrame";
import OnboardContact from "./OnboardContact";
import CustomLoader from "../../../../custom_components/CustomLoader";
import useTimeline from "../../../../hooks/useTimeline";
import useLoader from "../../../../hooks/useLoader";



const OnboardContactDetails = () => {

    const containerRef = useRef<HTMLDivElement>(null);
    const { set_window_width } = useTimeline()
    const { loading } = useLoader()

    useEffect(() => {
        const container = containerRef.current;
        if (container instanceof HTMLElement) {
            const width = container.offsetWidth;
            set_window_width(width - 32);
        }
    }, [containerRef.current, window.innerWidth])



    return (
        <div className='contact__container onboard__contact__container' ref={containerRef}>
            {loading &&
                <div className='container__loading'>
                    <CustomLoader loading={loading} />
                </div>
            }
            {!loading &&
                <Fragment>
                    <ContactTimeFrame />
                    <OnboardContact />
                </Fragment>
            }
        </div>
    )
}

export default OnboardContactDetails